import React, { useEffect } from 'react';
import { useConnectedUser } from '../context/connected-user.context';
import { Web3Button } from '../design-system/button';
import { SectionTitle } from '../design-system/title';
import { ConnectWalletButton } from '../components/connect-wallet/connect-wallet';
import { toast } from 'react-toastify';

export const Faucet: React.FC = () => {
    const connectedUserContext = useConnectedUser();

    const [display, setDisplay] = React.useState<boolean>(false);
    const [usdcAmount, setUsdcAmount] = React.useState<number>(0);
    const [usdcBalance, setUsdcBalance] = React.useState<number>(0);

    useEffect(() => {
        if (connectedUserContext.connectedUser && connectedUserContext.contract) {
            setDisplay(true);
            setUsdcBalance(connectedUserContext.connectedUser.usdcBalance)
        }
    }, [connectedUserContext.connectedUser]);

    const onFaucetSuccess = () => {
        toast.success('USDC received !');
        connectedUserContext.reloadAllBalances();
    };

    return (
        <>
            <SectionTitle title="Receive USDC" />
            {display && (
                <div>
                    <div>USDC balance: {usdcBalance}</div>
                    <div className="form-group">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter USDC amount wanted"
                            onChange={(e) => setUsdcAmount(Number(e.target.value))}
                        />
                        <Web3Button
                            text="Receive USDC"
                            disabled={usdcAmount <= 0}
                            web3Action={() => connectedUserContext.contract!.usdc.receiveUsdcFromFaucet(connectedUserContext.connectedUser!.walletAddress, usdcAmount)}
                            onSuccess={onFaucetSuccess}
                        />
                    </div>
                </div>
            )}
            {!display && (
                <div>
                    <div className="font-bold">Connect your wallet to receive USDC</div>
                    <div>
                        <ConnectWalletButton />
                    </div>
                </div>
            )}
        </>
    );
};
